import { defineAttrs as e } from "../../utils/typed-attrs.js";
var t = {
	inline: !1,
	group: "block",
	attrs: e({
		type: { default: "unsupportedElement" },
		unsupportedTypeName: { default: "" },
		text: { default: "" }
	}),
	parseDOM: [],
	toDOM(e) {
		return ["div"];
	}
};
//#endregion
export { t as unsupportedElementSpec };
